import { render } from "./manage-department.vue?vue&type=template&id=728428cb"
import script from "./manage-department.vue?vue&type=script&lang=js"
export * from "./manage-department.vue?vue&type=script&lang=js"

import "./manage-department.vue?vue&type=style&index=0&id=728428cb&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__